import { NoteIcon } from "components/Icons";
import { formatDateTime } from "../tools/functions";
import LabelKind from "./ui/LabelKind";
import LabelTime from "./ui/LabelTime";

function ItemLabel({ label, value, colSpan = "col-span-1" }) {
  const isJSX = typeof value === "object";

  return (
    <div className={`flex space-x-2 ${colSpan}`}>
      <span className="text-gray-500 shrink-0">{label}:</span>

      {isJSX ? value : <span className="font-semibold truncate">{value}</span>}
    </div>
  );
}

const ModalOrder = ({ order }) => {
  console.log("order...", order);

  if (!order) return null;

  const {
    sale_date,
    order_status,
    "table_assigned.": table,
    "party.": party,
    "lines.": lines,
    "order_status_time.": order_status_time,
    kind,
    "shop.": shop,
    "sale_device.": sale_device,
    "agent.": agent,
    pos_create_date,
  } = order;
  const time = order_status_time?.commanded ?? pos_create_date;

  return (
    <div className="w-full relative z-10 my-2">
      <div className="grid grid-cols-3 gap-x-3 gap-y-3 bg-gray-200 p-3 rounded-2xl">
        <ItemLabel label="Nombre" value={party.rec_name} type="label" />
        <ItemLabel
          label={table?.rec_name ? "Mesa" : "Tipo"}
          value={table?.rec_name || <LabelKind kind={kind} />}
        />
        <LabelTime time={time} />

        <ItemLabel label="Tienda" value={shop?.rec_name} />
        <ItemLabel label="Hora" value={formatDateTime(time, "time")} />

        <ItemLabel
          label="Terminal"
          value={sale_device?.rec_name ?? "SIN TERMINAL"}
        />
        <ItemLabel
          label="Creado por"
          value={agent?.rec_name}
          colSpan="col-span-2"
        />
        <ItemLabel label="Día" value={formatDateTime(sale_date, "date")} />
      </div>

      <div className="border-t border-dashed border-gray-300 py-3 mt-3">
        <h2 className="text-3xl">Orden</h2>
        <div className="mt-4 bg-gray-100 border border-gray-300 rounded-md">
          {lines?.map((line) => (
            <div
              key={line.id}
              className="grid grid-cols-2 divide-x divide-gray-400 w-full text-sm bg-gray-50 rounded-md px-3 py-2 even:bg-gray-100"
            >
              <div className="flex space-x-1">
                <span>{line.quantity}</span>
                <span className="font-bold text-green-800">x</span>
                <span>{line["product."]?.name}</span>
              </div>
              {line.note && (
                <div className="pl-2 flex items-center space-x-2">
                  <NoteIcon className="size-3.5 fill-current text-gray-600" />
                  <span className="text-xs text-gray-500 mt-1">
                    {line.note}
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      {order.comment && (
        <div className="border-t border-dashed border-gray-200 px-4 py-3">
          <span className="flex space-x-2 items-center font-bold mb-1">
            <span>Nota General: </span>
          </span>
          <p className="text-sm text-gray-500 ">{order.comment}</p>
        </div>
      )}
    </div>
  );
};

export default ModalOrder;
